export default [
  {
    name: 'login',
    method: 'post',
    desc: '登陆接口',
    path: '/obt/vipLogin',
    params: {
      loginType: 1,
      loginName: null,
      password: null,
      compId: null,
      corpId: null,
      openId: null,
      validateCode: null,
      validateCodeId: null,
      deviceId :null,//(string, optional): 设备标识 ,
      deviceShortname :null,//(string, optional): 设备型号 ,
      autologinType :null,//(integer, optional): 登陆方式,1-自动登录2-手动登录
    }
  },
  {
    name: 'userRegister',
    method: 'post',
    desc: '个人注册',
    path: '/obt/userRegister',
    params: {
      compId:'',
      smsCode:'',
      phoneNumber:'',
      userName: '',
      corpNo:''
    }
  },
  {
    name: 'userRegister4Gat',
    method: 'post',
    desc: 'GAT个人注册',
    path: '/obt/userRegister4Gat',
    params: {
      authCode:'',
      corpId:'',
    }
  },
  {
    name: 'getSmsCode',
    method: 'get',
    desc: '获取注册验证码',
    path: '/obt/getRegisterSmsCode',
    params: {

    }
  },
  {
    name: 'getCorpList',
    method: 'get',
    desc: '获取多个企业列表',
    path: '/obt/getCorpList',
    params: {
      loginType: 1,
      loginName: null,
      password: null,
      compId: null,
      validateCode: null,
      validateCodeId: null
    }
  },
  {
    name: 'vipEmpEditPwd',
    method: 'post',
    desc: '修改密码',
    path: '/obt/vipEmpEditPwd',
    params: {
      oldPwd: null,
      pwd: null
    }
  },
  {
    name: 'getLoginUserInfo',
    method: 'get',
    desc: '获取员工信息',
    path: '/obt/getLoginUserInfo',
    params: {
      refresh:''
    },
    loading:'0'
  },
  {
    name: 'vipEmpEditInfoObt',
    method: 'post',
    desc: '修改个人信息',
    path: '/obt/vipEmpEditInfoObt',
    params: {
      birthPlace: '',
      born: '',
      email: '',
      engName: '',
      idNumber: '',
      nation: '',
      oldIdNumber: '',
      passport: '',
      passportPeriod: '',
      phoneNumber: '',
      phoneNumber2: '',
      placeOfIssue: '',
      preference: '',
      sex: '',
      tel: '',
      civilBankId: '',
      civilBankName: '',
      civilCheck: '',
      isCivil: '',
      unitAddress:''
    }
  },
  {
    name: 'getCustomerInfoList',
    method: 'get',
    desc: '获取服务组电话',
    path: '/obt/getCustomerInfoList',
    params: {},
    loading: '0'
  },
  {
    name: 'passwordRetake',
    method: 'get',
    desc: '验证手机号',
    path: '/obt/passwordRetake',
    params: {}
  },
  {
    name: 'smsCodeGet',
    method: 'get',
    desc: '获取短信验证码',
    path: '/obt/smsCodeGet',
    params: {
      phoneNumber: '',
      type: '', // 场景类型描述(字符串格式 发送短信的格式:您正在，验证码为;)不能为空
      compId: '', // 总公司id
      isUpdate: '' // 是否修改手机号,'1'是修改否则不是修改}
    }
  },
  {
    name: 'smsCodeCheck',
    method: 'get',
    desc: '获取短信验证码校验',
    path: '/obt/smsCodeCheck',
    params: {
      phoneNumber: '',
      smsCode: ''
    }
  },
  {
    name: 'getValidateCode',
    method: 'get',
    desc: '获取验证码',
    path: '/obt/getValidateCode',
    params: {}
  },
  {
    name: 'vipLoginOut',
    method: 'post',
    desc: '退出登录',
    path: '/obt/vipLoginOut',
    params: {
      op: ''
    }
  },
  {
    name: 'getOpenId',
    method: 'post',
    desc: '传入code获取微信openid',
    path: '/obt/getOpenId',
    params: {
      code: '',
      companySuper:'',
      corpId: '',
      czly:'',
    }
  },
  {
    name: 'getMinOpenId',
    method: 'post',
    desc: '传入code获取微信openid',
    path: '/obt/personal/register/getMinOpenId',
    params: {
      code: '',
      companySuper:'',
      corpId: '',
      czly:'',
    }
  },
  {
    name: 'wxLogin',
    method: 'post',
    desc: '微信公众号 登录',
    path: '/obt/wxLogin',
    params: {
      openId:'',
      compId:''
    }
  },
  {
    name: 'getRegisterSmsCode',
    method: 'get',
    desc: '获取注册验证码',
    path: '/obt/getRegisterSmsCode',
    params: {
      corpId:'',
      compId: '',
      phoneNumber: '',
      corpNo:'',
    }
  },
  {
    name: 'saveVipCorpApply',
    method: 'post',
    desc: '保存在线企业申请表',
    path: '/obt/saveVipCorpApply',
    params: {
      fullname: '',//企业全称
      shortname: '',//企业简称
      address: '',//地址
      postCode: '',//邮编
      linkman: '',//联系人
      linkPhone: '',//联系手机
      email: '',//邮编
      province: '',//所在省份
      provinceName: '',//所在省份名称
      cityId: '',//所在城市
      cityName: '',//所在城市名称
      industry: '',//所属行业
      corpScale: '',//所属规模
      compId: ''
    }
  },
  {
    name: 'vipEmpResetPwd',
    method: 'post',
    desc: '获取注册验证码',
    path: '/obt/vipEmpResetPwd',
    params: {
      phoneNumber: '',
      pwd: '',
      smsCode: ''
    }
  },
  {
    name: 'phoneBinding',
    method: 'post',
    desc: '修改绑定手机',
    path: '/obt/phoneBinding',
    params: {
      phoneNumber: '',
      smsCode: ''
    }
  },
  {
    name: 'vipCancel',
    method: 'post',
    desc: '用户注销',
    path: '/obt/vipCancel',
    params: {
      'deviceId': '',
      'deviceShortname': ''
    }
  },
  {
    name: 'queryCompId',
    method: 'post',
    desc: '自动分配获取总公司ID',
    path: '/obt/queryCompId',
    params: {
      'allotType': 0,//分配方式 0-自己输入服务商代码 1-自动分配
      'compCode': ''
    }
  },
  {
    name: 'vipDeptTreeForEmpQr',
    method: 'get',
    desc: '二维码注册获取部门树',
    path: '/obt/vipDeptTreeForEmpQr',
    params: {
      'corpId':''
    }
  },
  { //POST /obt/userRegisterForQr
    name: 'userRegisterForQr',
    method: 'post',
    desc: '二维码邀请注册',
    path: '/obt/userRegisterForQr',
    params: {
      'name':'',// (string): 姓名 ,
      'phoneNumber':'',// (string): 手机号码 ,
      'email':'',// (string, optional): 邮箱 ,
      'empNo':'',// (string): 员工工号 ,
      'deptId':'',// (string): 当前所属部门ID ,
      'nation':'',// (string): 国籍 ,
      'idNumber':'',// (string, optional): 身份证号 ,
      'passport':'',// (string, optional): 护照号码 ,
      'passportPeriod':'',// (string, optional): 护照有效期 ,
      'placeOfIssue':'',// (string, optional): 证件签发地 ,
      'sex':'',// (string): 性别F男，M女 ,
      'born':'',// (string, optional): 出生年月YYYY ,
      'isCivil':'',// (integer, optional): 是否公务员 1是0否 默认0 ,
      'corpId':'',// (string): 企业ID ,
      'corpNo':'',// (string, optional): 企业编号
      'smsCode':'',// 短信验证码
    }
  },
]
